<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(53)"
      :class="index == 53 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 53" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 53"
      />
      <div>产出物库存区</div>
    </div>
    <div
      class="button"
      @click="selectMenu(54)"
      :class="index == 54 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 54" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 54"
      />
      <div>产出物入库信息</div>
    </div>
    <div
      class="button"
      @click="selectMenu(55)"
      :class="index == 55 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 55" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 55"
      />
      <div>产出物出库信息</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>

</style>
